import auth from '@/services/auth';

export default {
    getUser() {
        return auth.getAccountDetails().then(response => response.data)
    }
}

